import React from 'react'
import Link from 'next/link'

function Footer() {
  return (
    <footer>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Top area: Blocks */}
        <div className="grid sm:grid-cols-12 gap-8 py-8 md:py-12 border-t border-gray-200">
          {/* 1st block */}
          <div className="sm:col-span-12 lg:col-span-3">
            <div className="mb-2">
              {/* Logo */}
              <Link href="/">
                <a className="inline-block" aria-label="Tradly">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 126 126"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M63 0C97.7939 0 126 28.2061 126 63C126 97.7939 97.7939 126 63 126C28.2061 126 0 97.7939 0 63C0 28.2061 28.2061 0 63 0Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      opacity="0.5"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M63 119C93.9279 119 119 93.9279 119 63C119 32.0721 93.9279 7 63 7C32.0721 7 7 32.0721 7 63C7 93.9279 32.0721 119 63 119Z"
                      stroke="white"
                      stroke-width="1.4"
                    />
                    <path
                      opacity="0.5"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M63 105C86.196 105 105 86.196 105 63C105 39.804 86.196 21 63 21C39.804 21 21 39.804 21 63C21 86.196 39.804 105 63 105Z"
                      stroke="white"
                      stroke-width="1.4"
                    />
                    <path
                      d="M108.282 44.2442C105.799 38.2551 102.162 32.8652 97.6482 28.3518C88.7809 19.4845 76.5309 14 63 14C49.469 14 37.219 19.4845 28.3517 28.3518C23.8383 32.8652 20.2012 38.2551 17.7178 44.2442"
                      stroke="white"
                      stroke-width="15.4"
                      stroke-linecap="round"
                    />
                    <path
                      d="M63.0001 14.0001V111.222"
                      stroke="white"
                      stroke-width="15.4"
                      stroke-linecap="round"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="126"
                        y1="0"
                        x2="126"
                        y2="126"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#2BDBC0" />
                        <stop offset="1" stop-color="#13B58C" />
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
              </Link>
            </div>
            <div>
              <p className="text-sm text-gray-600 mt-2">
                TradlyPlatform is a Software as a Service (SaaS) helping startups launch commerce
                and multi-sided platforms with speed and minimal cost.
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Platform Model (circular / sharing / gig / on-demand) has the tremendous power to
                change the world. We are on a mission to make this technology accessible anyone to
                launch their idea.
              </p>
              <p className="mt-3">
                <Link href="/brand/purpose">
                  <a className="  text-base text-gray-800  font-medium">The Purpose & Why Tradly</a>
                </Link>
              </p>
              <br />
              <p className="text-sm text-gray-600  ">Product of iSTRATA Digital Sdn Bhd</p>
              <p className="mt-2 text-xs text-gray-600  ">
                WORQ TTDI, Glo Damansara Mall, Taman Tun Dr Ismail, 60000
                Kuala Lumpur, Malaysia
              </p>
              {/* Social links */}
              <p className="text-base text-gray-800 mt-3 font-medium">Follow us</p>
              <ul className="flex ">
                <li>
                  <Link href="https://twitter.com/TradlyPlatform">
                    <a
                      className="flex justify-center items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                      aria-label="Twitter"
                      target="_blank"
                    >
                      <svg
                        className="w-8 h-8 fill-current"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                      </svg>
                    </a>
                  </Link>
                </li>
                <li className="ml-4">
                  <Link href="https://github.com/TRADLY-PLATFORM">
                    <a
                      className="flex justify-center items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                      aria-label="Github"
                      target="_blank"
                    >
                      <svg
                        className="w-8 h-8 fill-current"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M16 8.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V22c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" />
                      </svg>
                    </a>
                  </Link>
                </li>
                <li className="ml-4">
                  <Link href="https://www.linkedin.com/showcase/tradly-platform/">
                    <a
                      className="flex justify-center items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                      aria-label="Facebook"
                      target="_blank"
                    >
                      <svg
                        className="w-8 h-8 fill-current"
                        width="20"
                        height="20"
                        viewBox="-6 -4 37 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M17.5002 8.999C16.605 8.99862 15.7236 9.22006 14.9348 9.64353C14.8628 9.45396 14.7349 9.29077 14.5679 9.17564C14.401 9.06052 14.203 8.99891 14.0002 8.999H10.0002C9.86887 8.99893 9.7388 9.02474 9.61744 9.07497C9.49608 9.1252 9.38582 9.19885 9.29294 9.29173C9.20007 9.3846 9.12641 9.49487 9.07618 9.61623C9.02595 9.73759 9.00014 9.86766 9.00022 9.999V21.999C9.00014 22.1303 9.02595 22.2604 9.07618 22.3818C9.12641 22.5031 9.20006 22.6134 9.29294 22.7063C9.38581 22.7992 9.49608 22.8728 9.61744 22.923C9.7388 22.9733 9.86887 22.9991 10.0002 22.999H14.0002C14.1316 22.9991 14.2616 22.9733 14.383 22.923C14.5043 22.8728 14.6146 22.7992 14.7075 22.7063C14.8004 22.6134 14.874 22.5031 14.9242 22.3818C14.9745 22.2604 15.0003 22.1303 15.0002 21.999V16.499C15.0002 16.2338 15.1056 15.9794 15.2931 15.7919C15.4806 15.6044 15.735 15.499 16.0002 15.499C16.2654 15.499 16.5198 15.6044 16.7073 15.7919C16.8949 15.9794 17.0002 16.2338 17.0002 16.499V21.999C17.0001 22.1303 17.026 22.2604 17.0762 22.3818C17.1264 22.5031 17.2001 22.6134 17.2929 22.7063C17.3858 22.7992 17.4961 22.8728 17.6174 22.923C17.7388 22.9733 17.8689 22.9991 18.0002 22.999H22.0002C22.1316 22.9991 22.2616 22.9733 22.383 22.923C22.5044 22.8728 22.6146 22.7992 22.7075 22.7063C22.8004 22.6134 22.874 22.5031 22.9242 22.3818C22.9745 22.2604 23.0003 22.1303 23.0002 21.999V14.499C22.9984 13.0409 22.4184 11.643 21.3873 10.6119C20.3562 9.58086 18.9583 9.00081 17.5002 8.999ZM21.0002 20.999H19.0002V16.499C19.0002 15.7034 18.6841 14.9403 18.1215 14.3777C17.5589 13.8151 16.7959 13.499 16.0002 13.499C15.2046 13.499 14.4415 13.8151 13.8789 14.3777C13.3163 14.9403 13.0002 15.7034 13.0002 16.499V20.999H11.0002V10.999H13.0002V11.7021C13.0003 11.9093 13.0648 12.1114 13.1847 12.2804C13.3045 12.4494 13.4739 12.577 13.6694 12.6456C13.865 12.7142 14.077 12.7204 14.2761 12.6634C14.4753 12.6063 14.6519 12.4888 14.7815 12.3271C15.2302 11.7572 15.8458 11.3416 16.5422 11.1384C17.2386 10.9352 17.9811 10.9545 18.6659 11.1937C19.3508 11.4329 19.9439 11.88 20.3624 12.4726C20.7809 13.0651 21.0039 13.7736 21.0002 14.499V20.999ZM7.00022 8.999H3.00022C2.86887 8.99893 2.7388 9.02474 2.61744 9.07497C2.49608 9.1252 2.38581 9.19885 2.29294 9.29173C2.20007 9.3846 2.12641 9.49487 2.07618 9.61623C2.02595 9.73759 2.00014 9.86766 2.00022 9.999V21.999C2.00014 22.1303 2.02595 22.2604 2.07618 22.3818C2.12641 22.5031 2.20006 22.6134 2.29294 22.7063C2.38581 22.7992 2.49608 22.8728 2.61744 22.923C2.7388 22.9733 2.86887 22.9991 3.00022 22.999H7.00022C7.13156 22.9991 7.26163 22.9733 7.38299 22.923C7.50435 22.8728 7.61462 22.7992 7.70749 22.7063C7.80037 22.6134 7.87402 22.5031 7.92425 22.3818C7.97448 22.2604 8.00029 22.1303 8.00022 21.999V9.999C8.00029 9.86766 7.97448 9.73759 7.92425 9.61623C7.87402 9.49487 7.80036 9.3846 7.70749 9.29173C7.61462 9.19885 7.50435 9.1252 7.38299 9.07497C7.26163 9.02474 7.13156 8.99893 7.00022 8.999ZM6.00022 20.999H4.00022V10.999H6.00022V20.999ZM5.01486 1.542C4.57723 1.5158 4.13883 1.5789 3.72634 1.72745C3.31385 1.87599 2.93589 2.10689 2.61543 2.40609C2.29498 2.7053 2.03873 3.06656 1.86227 3.4679C1.68582 3.86924 1.59284 4.30229 1.58899 4.74069C1.58515 5.1791 1.67051 5.61371 1.8399 6.01808C2.00929 6.42246 2.25916 6.78816 2.57431 7.09294C2.88947 7.39772 3.26332 7.63522 3.67314 7.79098C4.08296 7.94674 4.52018 8.01752 4.95822 7.999H4.98654C5.42533 8.02506 5.86484 7.96138 6.27819 7.81185C6.69155 7.66232 7.07007 7.43007 7.39064 7.12931C7.7112 6.82854 7.96707 6.46557 8.14262 6.06258C8.31817 5.65958 8.4097 5.22503 8.41163 4.78546C8.41356 4.34589 8.32584 3.91055 8.15383 3.50603C7.98183 3.10151 7.72915 2.73631 7.41123 2.43275C7.09332 2.12918 6.71685 1.89363 6.30482 1.74047C5.89279 1.58732 5.45386 1.51979 5.01485 1.542H5.01486ZM4.98655 5.999H4.95822C4.78528 6.02 4.60986 6.00378 4.44371 5.95143C4.27755 5.89908 4.12452 5.81181 3.99486 5.69547C3.8652 5.57912 3.76191 5.4364 3.69193 5.27688C3.62194 5.11735 3.58688 4.9447 3.58909 4.77051C3.58909 4.02441 4.14865 3.54199 5.01486 3.54199C5.18956 3.5187 5.36722 3.53312 5.53588 3.58428C5.70454 3.63543 5.86027 3.72213 5.9926 3.83854C6.12493 3.95495 6.23077 4.09837 6.303 4.25913C6.37524 4.41989 6.41218 4.59427 6.41135 4.77051C6.41135 5.5166 5.85178 5.999 4.98655 5.999Z" />
                      </svg>
                    </a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* 2nd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className="text-gray-800 font-medium mb-2">Platform</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <Link href="https://developer.tradly.app/">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    API First & Headless
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/how-it-works">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    How it works?
                  </a>
                </Link>
              </li>
              
              <li className="mb-2">
                <Link href="https://tradly.app/build-marketplace-native-apps-without-coding">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    No-Code
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/templates?category_id=4283">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    B2C Commerce
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/templates?category_id=3864">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Directories & SaaS Portals
                  </a>
                </Link>
              </li>
          
              <li className="mb-2">
                <Link href="/templates?category_id=3865">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    C2C/P2P Marketplaces
                  </a>
                </Link>
              </li>
              {/* <li className="mb-2">
                <Link href="#">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Web Studio
                  </a>
                </Link>
              </li> */}
              {/* <li className="mb-2">
                <Link href="#">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Web Studio
                  </a>
                </Link>
              </li> */}
            </ul>
          </div>

          {/* 3rd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className="text-gray-800 font-medium mb-2">Developer Resources</h6>
            <ul className="text-sm">
            <li className="mb-2">
                <Link href="https://marketplace.tradly.app">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Marketplace Ecosystem
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://github.com/TRADLY-PLATFORM">
                  <a
                    target="_blank"
                    className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out"
                  >
                    Open Source Apps
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://community.tradly.app/c/api-changelog/11">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Changelogs
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://developer.tradly.app/">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    API Reference
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://www.npmjs.com/package/tradly">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Js SDK
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://github.com/TRADLY-PLATFORM/puffin/projects/1">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Roadmap
                  </a>
                </Link>
              </li>
            </ul>
          </div>

          {/* 4th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className="text-gray-800 font-medium mb-2">Support</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <Link href="https://community.tradly.app/">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Community forum
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://tradly.app/docs/setup">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Product Guides
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://www.youtube.com/channel/UCRpXlfFBX5nayubY70-IFEA">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Video Tutorials
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/affiliate">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Affiliates
                    </a>
                </Link>
              </li>
              
              {/* <li className="mb-2">
                <Link href="#">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Web Studio
                  </a>
                </Link>
              </li> */}
              {/* <li className="mb-2">
                <Link href="#">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Web Studio
                  </a>
                </Link>
              </li> */}
            </ul>
          </div>

          {/* 5th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-3">
            <h6 className="text-gray-800 font-medium mb-2">Use cases</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <Link href="/build-a-marketplace-app-that-fashion-retailers-and-shoppers-love">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Fashion Marketplace
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/building-grocery-delivery-app-like-instacart-doordash-postmates">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Grocery Marketplace
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/building-an-donation-marketplace-app-like-thrift">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Donation Marketplace
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="/energy">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Alternative Energy Marketplace
                  </a>
                </Link>
              </li>
             
              <li className="mb-2">
                <Link href="https://istrata.co/smart-public-participation-platform-for-government-and-citizen-engagement/">
                  <a
                    target="_blank"
                    className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out"
                  >
                    Public Participation | CrowdSourcing
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href=" /launch-your-circulareconomy-business-from-recycle-marketplace-to-n">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Circular Economy Model
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href=" /building-a-trash-waste-recycle-management-smart-apps">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Recycle / Trash / Waste Management Platform
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href=" /free-best-e-commerce-for-influencers">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Free E-Commerce for Influencers and Creators
                  </a>
                </Link>
                <li className="mb-2">
                <Link href=" /store/free-classified-website">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Free Classified Website
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href=" /store/how-to-start-online-store-free">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Free Online Store
                  </a>
                </Link>
              </li>
              <li className="mb-2">
                <Link href="https://tradly.app/booking/event-management-software">
                  <a className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out">
                    Free Event Booking Software
                  </a>
                </Link>
              </li>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom area */}
        <div className=" md:flex md:items-center md:justify-between py-4   border-t border-gray-200">
          <div className="text-sm text-gray-600 flex flex-wrap gap-5">
            <Link href="https://tradly.app/terms-conditions">
              <a className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out">
                Terms
              </a>
            </Link>{' '}
            <Link href="https://tradly.app/privacy-policy">
              <a className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out">
                Privacy Policy
              </a>
            </Link>
            <Link href="/sitemap-index.xml">
              <a className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out">
                Sitemap
              </a>
            </Link>
            <Link href="/glossary">
            <a className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out">
                Glossary
              </a>
            </Link>
            <Link href="/store/storeindex">
              <a className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out">
                Store Index
              </a>
            </Link>
          </div>

          {/* Copyrights note */}
          <div className=" mt-4 md:mt-0 text-sm text-gray-600 mr-4">
            &copy; 2025 Tradly. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
